import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=43f95833&scoped=true&"
import script from "./Leaderboard.vue?vue&type=script&lang=js&"
export * from "./Leaderboard.vue?vue&type=script&lang=js&"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=43f95833&prod&lang=css&"
import style1 from "./Leaderboard.vue?vue&type=style&index=1&id=43f95833&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f95833",
  null
  
)

export default component.exports